var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.33317 14.6668C3.15636 14.6668 2.98679 14.5966 2.86177 14.4716C2.73674 14.3465 2.6665 14.177 2.6665 14.0002V2.00016C2.6665 1.82335 2.73674 1.65378 2.86177 1.52876C2.98679 1.40373 3.15636 1.3335 3.33317 1.3335H12.6665C12.8433 1.3335 13.0129 1.40373 13.1379 1.52876C13.2629 1.65378 13.3332 1.82335 13.3332 2.00016V4.00016H11.9998V2.66683H3.99984V13.3335H11.9998V12.0002H13.3332V14.0002C13.3332 14.177 13.2629 14.3465 13.1379 14.4716C13.0129 14.5966 12.8433 14.6668 12.6665 14.6668H3.33317ZM11.9998 10.6668V8.66683H7.33317V7.3335H11.9998V5.3335L15.3332 8.00016L11.9998 10.6668Z"
  })));
};
export default SvgExit;